import React from "react";
import MaybeUrgencyBox from "./MaybeUrgencyBox";
import { ECommerceStatus } from "src/ssc-api/useECommerceStatus";
import { match } from "ts-pattern";
import { useLingui } from "@lingui/react/macro";

type Props = {
  destinationWebCode: string | undefined;
  destinationName: string | undefined;
  ecommerceUrl: ECommerceStatus;
};
const CruiseUrgencyBox: React.FC<Props> = ({
  destinationWebCode,
  destinationName,
  ecommerceUrl
}) => {
  const { t } = useLingui();
  const ctaUrl = match(ecommerceUrl)
    .with({ type: "ecommerce" }, ({ ecommerceUrl }) => ecommerceUrl)
    .with({ type: "priceconfig" }, ({ url }) => url)
    .otherwise(() => undefined);

  if (!ctaUrl) return null;

  return (
    <MaybeUrgencyBox
      destinationWebCode={destinationWebCode}
      title={t`${destinationName} cruises are booking fast`}
      content={t`Secure your suite`}
      ctaUrl={ctaUrl}
      ctaLabel={t`Book your suite`}
    />
  );
};

export default CruiseUrgencyBox;
